import InputTypes from 'utils/enums/inputTypes';
import { IField } from 'utils/interfaces/IField';

const lessonPlan: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do plano de estudos',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default lessonPlan;
